module.exports = __webpack_public_path__ + "img/cross.eb870e52.webp";